import { type DeepWriteable } from '@shared/typings';
import { useCloned } from '@vueuse/core';

// Clone a DeepReadonly object and make the clone writable
export default <T>(original: T): DeepWriteable<T> => {
    const writableOriginal: DeepWriteable<T> = original as DeepWriteable<T>;
    const { cloned } = useCloned(writableOriginal);
    return cloned.value;
};
